module.exports = __webpack_public_path__ + "static/media/icemin.1507ae1f.jpg";